// src/components/Loader.jsx
import React from "react";

export default function Loader() {
  return (
    <div
      className="loader"
      style={{
        textAlign: "center",
        fontSize: "18px",
        color: "#007bff",
        marginTop: "20px",
      }}
    >
      ⏳ Extracting questions...
    </div>
  );
}
